import { api } from "../../server/request";
import { handleResponse, handleError } from "../responseUtil";
import { SET_LOADING, SOFTWARE_PRODUCT, SET_SOFTWARE_LISTING_LOADING, SOFTWARE_LISTING, GET_SOFTWARE_VERSIONS_DEVICE_COUNT, GET_SOFTWARE_VERSION_DEVICE_DETAILS, GET_SOFT_VERSION_DEVICE_DETAILS, GET_KONNECT_APP_DOWNLOAD_LINKS, GET_DP_DOCUMENTS_LIST, GET_VX_BUILD_DETAILS } from "../types";
import _ from "lodash"
export const softwareProduct = () => (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  api
    .getRequest("/edge/softwares/getProducts")
    .then((res) => handleResponse(res, dispatch, SOFTWARE_PRODUCT))
    .catch((err) => handleError(err, dispatch));
};

export const softwareListing = (dpId,type, productName, sort, sortOrder, page, limit) => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  if (_.isEmpty(dpId)) {
    dpId = ""
  }
  api
    .getRequest(`/edge/softwares/search?dpId=${dpId}&type=${type}&productName=${productName}&sort=${sort}&sortOrder=${sortOrder}&page=${page}&limit=${limit}`)
    .then((res) => handleResponse(res, dispatch, SOFTWARE_LISTING))
    .catch((err) => handleError(err, dispatch));
};

export const getSoftwareVersionsDeviceCount = (vessels, sort = "", sortOrder = "") => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  let _parameters: any = {
        "k4Ids": vessels && vessels.map((vs) => `'${vs.id}'`).join(','),
        "sortColumn": sort,
        "sortOrder": sortOrder
    };
  const data = {
        query:`GET_SW_VERSION_COUNT`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, GET_SOFTWARE_VERSIONS_DEVICE_COUNT)
            dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: false});
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: false});
        });
};

export const getSoftwareVersionDeviceDetails = (ouName, ouId, softwareVersion, search = "", page = -1, limit = -1, sort = "", sortOrder = "") => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  api
    .getRequest(`/edge/softwares/versions/${softwareVersion}/devices?ouName=${encodeURIComponent(ouName)}&ouId=${ouId}&page=${page}&limit=${limit}&sort=${sort}&sortOrder=${sortOrder}&search=${search}`)
    .then((res) => handleResponse(res, dispatch, GET_SOFTWARE_VERSION_DEVICE_DETAILS))
    .catch((err) => handleError(err, dispatch));
};

export const getDeviceDetails = (ouName, ouId, search = "", page = -1, limit = -1, sort = "", sortOrder = "") => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  api
    .getRequest(`/edge/softwares/versions/devices?ouName=${encodeURIComponent(ouName)}&ouId=${ouId}&page=${page}&limit=${limit}&sort=${sort}&sortOrder=${sortOrder}&search=${search}`)
    .then((res) => handleResponse(res, dispatch, GET_SOFT_VERSION_DEVICE_DETAILS))
    .catch((err) => handleError(err, dispatch));
};

export const getKonnectDownloadLinks = () => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  api
    .getRequest(`/edge/softwares/konnect/versions?latest=true&os=windows,mac,mac-intel`)
    .then((res) => handleResponse(res, dispatch, GET_KONNECT_APP_DOWNLOAD_LINKS))
    .catch((err) => handleError(err, dispatch));
};

export const getVxBuildsDetails = (dpId) => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  if (_.isEmpty(dpId)) {
    dpId = ""
  }
  api
    .getRequest(`/edge/softwares/vx/versions/v2/download?dpId=${dpId}`)
    .then((res) => handleResponse(res, dispatch, GET_VX_BUILD_DETAILS))
    .catch((err) => handleError(err, dispatch));
};

export const getDpDocumentList = (dpId) => (dispatch) => {
  dispatch({ type: SET_SOFTWARE_LISTING_LOADING, payload: true });
  api
    .getRequest(`/edge/softwares/documents/${dpId}`)
    .then((res) => handleResponse(res, dispatch, GET_DP_DOCUMENTS_LIST))
    .catch((err) => handleError(err, dispatch));
};